var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 25C26.9375 22.375 28.1875 18 27.4375 13.8125H16.25V18.4375H22.625C22.375 19.9375 21.5 21.1875 20.25 22L24.125 25Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 21.3125C6.44719 22.9321 7.62631 24.344 9.0735 25.4416C10.5207 26.5392 12.1982 27.294 13.9795 27.6491C15.7608 28.0042 17.5995 27.9502 19.3569 27.4913C21.1143 27.0324 22.7447 26.1806 24.125 25L20.25 22C16.9375 24.1875 11.4375 23.375 9.5625 18.25L5.625 21.3125Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56262 18.25C9.06262 16.6875 9.06262 15.25 9.56262 13.6875L5.62512 10.625C4.18762 13.5 3.75012 17.5625 5.62512 21.3125L9.56262 18.25Z",
    fill: "#FBBC02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 13.6866C10.9375 9.37406 16.8125 6.87406 20.75 10.5616L24.1875 7.18656C19.3125 2.49906 9.8125 2.68656 5.625 10.6241L9.5625 13.6866Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.b2c2dde7da1261736cc905fa0fdf2831.svg";
export { ForwardRef as ReactComponent };